import { SeoLanguageLocale } from 'src/utils/getSeoLanguageLocale';

type AlternateLink = {
  href: string;
  hrefLang: SeoLanguageLocale | 'x-default';
};

export const getDefaultAlternateLink = (alternateLinks: AlternateLink[]): AlternateLink | null => {
  const defaultLink =
    alternateLinks.find(({ hrefLang }) => hrefLang === 'en') ||
    alternateLinks.find(({ hrefLang }) => hrefLang === 'en-us');

  return defaultLink
    ? {
        hrefLang: 'x-default',
        href: defaultLink.href,
      }
    : null;
};

export const extendAlternateLinksWithDefault = (
  alternateLinks: AlternateLink[],
): AlternateLink[] => {
  const defaultLink = getDefaultAlternateLink(alternateLinks);

  return defaultLink ? [...alternateLinks, defaultLink] : alternateLinks;
};
